module.exports = __webpack_public_path__ + "static/media/difc_login_background.a7099204.jpg";